<template>
  <path
    d="M21.7002 20.3002L18.0002 16.6002C21.1002 12.7002 20.5002 7.00024 16.6002 3.90024C12.7002 0.800239 7.00024 1.50024 3.90024 5.30024C0.800239 9.20024 1.50024 14.9002 5.30024 18.0002C8.60024 20.6002 13.3002 20.6002 16.6002 18.0002L20.3002 21.7002C20.7002 22.1002 21.3002 22.1002 21.7002 21.7002C22.1002 21.3002 22.1002 20.7002 21.7002 20.3002ZM11.0002 18.0002C7.10024 18.0002 4.00024 14.9002 4.00024 11.0002C4.00024 7.10024 7.10024 4.00024 11.0002 4.00024C14.9002 4.00024 18.0002 7.10024 18.0002 11.0002C18.0002 14.9002 14.9002 18.0002 11.0002 18.0002Z"
    fill="currentColor"
  />
</template>
